import React from 'react'
import styled from 'styled-components'
import {
  Button,
  Box,
  Card,
  Container,
  Divider,
  Flex,
  theme,
  Hide
} from 'pcln-design-system'
import { Gpt } from '@pcln/ad-unit'
import HeroImageParallax from '../Heros/HeroImageParallax'
import Form from './SearchForm/Form'
import { handleSubmitForHotels } from './SearchForm/utils'
import StyledHeading from '../StyledHeading'
import HotelsContent from './HotelsContent'
import {
  PRIMARY_HEADING_FALLBACK,
  SECONDARY_HEADING_FALLBACK,
  BANNER_TEXT_PRIMARY,
  BANNER_TEXT_SECONDARY
} from './constants'
import ExpressDealModal from './ExpressDeal/ExpressDealModal'
import useExpressDealModal from './ExpressDeal/useExpressDealModal'
import RotatingBanner from '../RotatingBanner'
import HotelHeroImageSrc from '../../assets/images/pcln-hp-hero-hotels.jpg'
import HotelHeroImageWebpSrc from '../../assets/images/pcln-hp-hero-hotels.webp'
import HotelBumperImageSrc from '../../assets/images/hotelBumper.png'

const BlockFlex = styled(Box)`
  position: relative;
  z-index: 1;
  display: block;
  height: auto;
  ${theme.mediaQueries[3]} {
    display: flex;
  }
`

const HideFlexNone = styled(Hide)`
  text-align: center;
  position: relative;
  margin: 16px;
  min-height: 100px;
  ${theme.mediaQueries[3]} {
    width: 300px;
    flex: none;
    margin: 0 16px;
  }
`

const HotelsDesktop = () => {
  const { isOpen, openModal } = useExpressDealModal()
  return (
    <Box>
      <ExpressDealModal isModalOpen={isOpen} />
      <HeroImageParallax
        image={HotelHeroImageSrc}
        imageWebP={HotelHeroImageWebpSrc}
        gptId="div-gpt-ad-1509978154282-0"
        slot="/3102/priceline.dart/hotel_homepage_hero_image"
      >
        <Container maxWidth={1280}>
          <BlockFlex py={[3, null, null, null, 5]} alignItems="flex-start">
            <Box px={3} width={1}>
              <Card borderWidth={0} bg="background.lightest">
                <Box p={3} width={1}>
                  <Flex flexDirection="column" my={3}>
                    <StyledHeading
                      aceContent={[
                        'SITE-X.HOTELSLANDING.SEARCHAREA.HEADING.HEADLINE'
                      ]}
                      text={PRIMARY_HEADING_FALLBACK}
                      fontSize={[3, 4, 4, 4, 5]}
                      tag="h1"
                    />
                    <StyledHeading
                      color="text.light"
                      fontSize={[1, 3, 3, 3, 4]}
                      aceContent={[
                        'SITE-X.HOTELSLANDING.SEARCHAREA.HEADING.SUBHEADLINE'
                      ]}
                      text={SECONDARY_HEADING_FALLBACK}
                      tag="h2"
                    />
                  </Flex>
                  <Form onSubmit={handleSubmitForHotels} />
                </Box>
                <Divider m={0} />
                <Hide xs sm>
                  <Box>
                    <Button
                      color="background.light"
                      onClick={openModal}
                      p={3}
                      width={1}
                      aria-label={BANNER_TEXT_PRIMARY}
                    >
                      <RotatingBanner
                        height="25px"
                        image={HotelBumperImageSrc}
                        imageBackgroundColor="background.light"
                        primaryBannerText={BANNER_TEXT_PRIMARY}
                        secondaryBannerText={BANNER_TEXT_SECONDARY}
                      />
                    </Button>
                  </Box>
                </Hide>
              </Card>
            </Box>
            <HideFlexNone xs sm>
              <Gpt render={() => <div id="div-gpt-ad-1510170073577-0" />} />
            </HideFlexNone>
          </BlockFlex>
        </Container>
      </HeroImageParallax>
      <Hide xs sm color="background.lightest">
        <HotelsContent />
      </Hide>
    </Box>
  )
}

export default HotelsDesktop
